import { z } from 'zod';

export const WidgetActionsSchema = z.enum([
  'open-widget',
  'open-chat',
  'set-view-chat',
  'set-questionnaire-field-values',
  'set-custom-context',
  'clear-session',
  'start-direct-chat',
  'send-message',
]);

export type WidgetActions = z.infer<typeof WidgetActionsSchema>;

export const WidgetActionsObjectSchema = z.object({
  action: WidgetActionsSchema,
  data: z.unknown().optional(),
  context: z
    .object({
      source: z.string().optional(),
      customMessage: z.string().optional(),
    })
    .optional(),
});

export type WidgetActionsObject = z.infer<typeof WidgetActionsObjectSchema>;
